var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('CandleStick',{staticStyle:{"height":"800px"},attrs:{"stockConfig":{ stockCode: _vm.stockCode },"options":_vm.options,"extremes":_vm.extremes,"quoteData":_vm.quoteData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }